import {GET_REASONS_FOR_REJECT} from "../../../enums/Documents/DocumentsType";

export const getReasonsForReportAction = (data) => {
    return {
        type: GET_REASONS_FOR_REJECT,
        payload: data,
    };
};
